import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Modal, Button, Paper, PaperHeadline, PaperContent, Text } from '../..'

export class PetplaceCancelInsurancePolicyModal extends Component {
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    errorMessage: PropTypes.string,
    className: PropTypes.string,
    title: PropTypes.string,
    successText: PropTypes.string,
    cancelInsuranceButtonText: PropTypes.string,
    closeButtonText: PropTypes.string,
    id: PropTypes.string,
    cancelInsuranceButtonProps: PropTypes.shape({
      id: PropTypes.string,
      onClick: PropTypes.func
    }),
    closeButtonProps: PropTypes.shape({
      id: PropTypes.string,
      onClick: PropTypes.func
    })
  }

  static defaultProps = {
    title: "",
    closeButtonText: "Keep My Coverage",
    cancelInsuranceButtonText: "Cancel My Policy",
  }

  render() {
    const {
      open,
      onClose,
      className,
      id,
      title,
      errorMessage,
      cancelInsuranceButtonText,
      closeButtonText,
      successText,
      cancelInsuranceButtonProps,
      closeButtonProps
    } = this.props

    return (
      <Modal
        open={open}
        onClose={onClose}
        className={className}
        id={id}
        refProp
      >
        <div className='ui-petplace-cancel-policy-modal'>
          <Paper>
            <PaperHeadline> Cancel Insurance Policy </PaperHeadline>
            <PaperContent className='ui-petplace-cancel-policy-modal-content'>
              {errorMessage && (
                <Text
                  className='ui-petplace-cancel-policy-modal__error-message'
                  type={Text.Types.bodyBold}
                >
                  {errorMessage}
                </Text>
              )}
              {!successText && <Text type={Text.Types.body}>
                {title}
                <br></br><br></br>
                Cancelled policies are ineligible for reinstatement.
              </Text>}
                {successText && <Text type={Text.Types.body} className="ui-petplace-cancel-policy-card__text">
                  {successText}
                </Text> }
              <div className='ui-petplace-cancel-policy-modal__actions'>
                <Button
                  variant={Button.Variants.outlined}
                  size={Button.Sizes.small}
                  {...closeButtonProps}
                >
                  {closeButtonText}
                </Button>
                {!successText && (
                  <Button
                    type='button'
                    size={Button.Sizes.small}
                    variant={Button.Variants.filled}
                    {...cancelInsuranceButtonProps}
                  >
                    {cancelInsuranceButtonText}
                  </Button>
                )}
              </div>
            </PaperContent>
          </Paper>
        </div>
      </Modal>
    )
  }
}
